import { LandingComponent } from './../landing/landing.component';
import { RegisterComponent } from './../register/register.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // { path: '', redirectTo: 'register', pathMatch: 'full' },
  // { path: 'register', component: RegisterComponent },
  // { path: 'register/:id', component: RegisterComponent }

  { path: '', pathMatch: 'full', component: RegisterComponent },
  // { path: 'register', component: RegisterComponent }
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
  declarations: []
})
export class RegisterRouterModule {}



// WEBPACK FOOTER //
// ./src/app/router/register.router.module.ts